import { api } from '../configs/apiConfig'; // Adjust the import path as necessary

const ORG_UNIT_TYPE_ENDPOINT = '/organizationalunittype';

class OrganizationalUnitTypeService {
    // Get all organizational unit types
    async getAllTypes() {
        try {
            const response = await api.get(ORG_UNIT_TYPE_ENDPOINT);
            return response.data;
        } catch (error) {
            console.error('Error fetching organizational unit types:', error);
            throw error;
        }
    }

    // Get organizational unit type by ID
    async getTypeById(id) {
        try {
            const response = await api.get(`${ORG_UNIT_TYPE_ENDPOINT}/${id}`);
            return response.data;
        } catch (error) {
            console.error(`Error fetching organizational unit type with ID ${id}:`, error);
            throw error;
        }
    }

    // Add a new organizational unit type
    async addType(typeData) {
        try {
            const response = await api.post(ORG_UNIT_TYPE_ENDPOINT, typeData);
            return response.data;
        } catch (error) {
            console.error('Error adding organizational unit type:', error);
            throw error;
        }
    }

    // Update an existing organizational unit type
    async updateType(id, typeData) {
        try {
            await api.put(`${ORG_UNIT_TYPE_ENDPOINT}/${id}`, typeData);
        } catch (error) {
            console.error(`Error updating organizational unit type with ID ${id}:`, error);
            throw error;
        }
    }

    // Delete an organizational unit type
    async deleteType(id) {
        try {
            await api.delete(`${ORG_UNIT_TYPE_ENDPOINT}/${id}`);
        } catch (error) {
            console.error(`Error deleting organizational unit type with ID ${id}:`, error);
            throw error;
        }
    }
}

export default new OrganizationalUnitTypeService(); 